import {Clipboard} from "ts-clipboard";

import primaryLogo from "assets/img/primaryLogo.png";
import primaryLogoOLG from "assets/img/primaryLogo-OLG.png";
import primaryLogoMGM from "assets/img/primaryLogo-MGM.png";
import {get} from "lodash-es";

export const isMobile = () =>
	window.matchMedia
		? window.matchMedia("(max-width: 480px)").matches
		: false;

export const isMatchMaxWidth = (maxWidth: number) =>
	!matchMedia || matchMedia(`(max-width: ${maxWidth}px)`).matches;

export const toggleBodyClass = (class_name: string, state: boolean, name: string = "all") => {
	if (state) {
		document.body.classList.add(`${class_name}-${name}`);
	} else {
		document.body.classList.remove(`${class_name}-${name}`);
	}
};

export const removeBodyClass = (class_name: string) => {
	document.body.classList.remove(class_name);
};

export const buildWithPlural = (num: number) => {
	const pr = new Intl.PluralRules("en-US", {type: "ordinal"});

	const suffixes = new Map([
		["one", "st"],
		["two", "nd"],
		["few", "rd"],
		["other", "th"],
	]);

	const rule = pr.select(num);
	const suffix = suffixes.get(rule);

	if (suffix) {
		return `${String(num)}${String(suffix)}`;
	}

	return String(num);
};

/* eslint-disable @typescript-eslint/no-magic-numbers, sonarjs/function-return-type */
export const formatCash = (n: number) => {
	if (n < 1e3) return n;

	if (n >= 1e3 && n < 1e6) {
		return `${(n / 1e3).toFixed(1)}K`;
	}
	if (n >= 1e6 && n < 1e9) {
		return `${(n / 1e6).toFixed(1)}M`;
	}

	return "too long number";
};
/* eslint-enable @typescript-eslint/no-magic-numbers, sonarjs/function-return-type */

export const copyToClipboard = async (text: string): Promise<boolean> => {
	if (navigator?.clipboard) {
		try {
			await navigator.clipboard.writeText(text);
			return true;
		} catch (e) {
			console.info(e);
		}
	}

	try {
		Clipboard.copy(text);
		return true;
	} catch (e) {
		console.info(e);
		return false;
	}
};

export const getLogoAccordingState = (
	countryCode: null | string,
	stateCode: null | string
): string => {
	if (!countryCode) {
		return primaryLogo;
	}

	if (countryCode === "CA" && stateCode === "ON") {
		return primaryLogoOLG;
	}
	if (countryCode === "US") {
		return primaryLogoMGM;
	}

	return primaryLogo;
};

const ruleLinks = {
	US: "https://www.mlb.com/apps/beat-the-streak/official-rules",
	"CA.ON": "https://www.mlb.com/apps/beat-the-streak/official-rules-ca",
};
export function getRulesLinkAccordingState(
	countryCode: null | string,
	stateCode: null | string
): string {
	if (!countryCode || !stateCode) {
		return ruleLinks.US;
	}

	return get(ruleLinks, `${countryCode}.${stateCode}`, ruleLinks.US);
}
